import axios, { type AxiosResponse } from 'axios';

import { logToSentry } from '@jsmdg/react-fragment-scripts/fragment';
import { type ReviewsWidgetData } from '../../shared/reviews';

export const fetchProductReviewsWidgetData = async (
    productId: string,
    tenant: string,
): Promise<ReviewsWidgetData | null> => {
    try {
        const { data }: AxiosResponse<ReviewsWidgetData> = await axios.get(
            'api/reviews/widget-data',
            {
                params: {
                    productId,
                    tenant,
                },
            },
        );

        return data;
    } catch (error) {
        logToSentry(error as Error);

        return null;
    }
};
